import React from 'react'
import { ReactComponent as TruckIcon } from '../../ui/markSearchIcons/truck.svg';
import { ReactComponent as CarIcon } from "../../ui/markSearchIcons/car.svg"
import { ReactComponent as HeavyCarIcon } from "../../ui/markSearchIcons/heavyCar.svg"
import { ReactComponent as TrailerIcon } from "../../ui/markSearchIcons/trailer.svg"
import styles from "./radioButtonsGroup.module.css"
export function RadioButtonsGroup({ value, onChange }) {
    const name = "brand"
    const items = [{
        id: 1, value: `1`, label: "Легковой автомобиль", icon: <CarIcon className={styles.icon} />
    }, {
        id: 2, value: `2`, label: "Грузовой автомобиль", icon: <TruckIcon className={styles.icon} />
    },
    {
        id: 3, value: `3`, label: "Спецтехника", icon: <HeavyCarIcon className={styles.icon} />
    }, {
        id: 4, value: `4`, label: "Прицепы", icon: <TrailerIcon className={styles.icon} />
    }]

    return (
        <form className={styles.container}>
            {items.map((item) => {
                return (

                    <div className={styles.input_wrapper} key={item.value}>
                        <input
                            className={styles.radio_button}
                            type='radio'

                            name={name}
                            id={`${name}-${item.id}`}
                            checked={value === item.value}
                            onChange={(e) => {
                                onChange(e.target.value);
                            }}
                            value={item.value}
                        />
                        <label className={styles.label} htmlFor={`${name}-${item.value}`}>{item.label}</label>
                    </div>
                );
            })}
        </form>
    )
}
